export default "<div class=\"live-container\">\n  <div class=\"random-bar\"></div>\n</div>\n"